import { render, staticRenderFns } from "./EdgeElement.vue?vue&type=template&id=385fd896&scoped=true&"
import script from "./EdgeElement.vue?vue&type=script&lang=js&"
export * from "./EdgeElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "385fd896",
  null
  
)

export default component.exports